import React, { Suspense } from "react"
import { useTexture } from '@react-three/drei'
import { useVideoTexture } from "../useVideoTexture"

export function VideoMaterial({ url, material }) {
  const texture = useVideoTexture(url)
  return <meshBasicMaterial ref={material} map={texture} toneMapped={false} />
}

export function FallbackMaterial({ url, material }) {
  const texture = useTexture(url)
  return <meshBasicMaterial ref={material} map={texture} toneMapped={false} />
}

export default function Video({material, fallback, video}){
    return (
    <Suspense fallback={<FallbackMaterial url={fallback} />}>
      <VideoMaterial material={material} url={video} />
    </Suspense>
    );
}
